import { CaseClusterWhereInput, PatientCaseWhereInput } from '@/@generated/codegen/API';
import { useQueryParams } from '@/hooks/useQueryParams';
import { QUERY_PARAM_GLOBAL_FILTER_KEY } from '@/hooks/useTableQueryParamsUtils';
import { parseDateQueryParam } from '@/utils/query-params/parseDateQueryParam';
import { parseStringQueryParam } from '@/utils/query-params/parseStringQueryParam';
import { useOrderByQueryParam } from '@/utils/query-params/useOrderByQueryParam';
import { usePaginationQueryParam } from '@/utils/query-params/usePaginationQueryParam';

export const useAdminCaseClusterListQueryParams = (pageSize: number, prefix: string | null) => {
  const queryObject = useQueryParams(
    [
      QUERY_PARAM_GLOBAL_FILTER_KEY,
      'createdAt',
      'updatedAt',
      'name',

      'cases', // NOTE: Searches legacyId and name
      'meetingName',
      'clientName',
    ],
    prefix
  );

  const { q, createdAt, updatedAt, name } = queryObject;
  const orderByArgs = useOrderByQueryParam(prefix);
  const paginationArgs = usePaginationQueryParam(pageSize, prefix);
  const casewhereInput: PatientCaseWhereInput = {
    OR: [
      {
        legacyCaseId: parseStringQueryParam(q),
      },
      {
        name: parseStringQueryParam(q),
      },
    ],
  };
  const where: CaseClusterWhereInput = {
    AND: [
      q
        ? {
            OR: [
              { id: parseStringQueryParam(q) },
              { name: parseStringQueryParam(q) },
              {
                cases: {
                  some: casewhereInput,
                },
              },
              {
                meetings: {
                  some: {
                    name: parseStringQueryParam(q),
                  },
                },
              },
              {
                clients: {
                  some: {
                    name: parseStringQueryParam(q),
                  },
                },
              },
            ],
          }
        : {},
      {
        name: parseStringQueryParam(name),
        createdAt: parseDateQueryParam(createdAt),
        updatedAt: parseDateQueryParam(updatedAt),
      },
      queryObject.clientName
        ? {
            clients: {
              some: {
                name: parseStringQueryParam(queryObject.clientName),
              },
            },
          }
        : {},
      queryObject.meetingName
        ? {
            meetings: {
              some: {
                name: parseStringQueryParam(q),
              },
            },
          }
        : {},
      queryObject.cases
        ? {
            cases: {
              some: casewhereInput,
            },
          }
        : {},
    ],
  };

  return {
    paginationArgs,
    orderByArgs,
    where,
  };
};
